import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { quickCreateAccessTagAsync } from "../../features/user/userSlice";
import LinkedItemsField, { MenuAction } from "./LinkedItemsField";

export const useIsCreatingAccessTag = () =>
  useSelector(state => state.user.pendingAccessTagTitles?.length > 0);

export default function AccessTagsField({
  id,
  value = [],
  onChange,
  platformId,
  options: restrictedOptions,
  canCreate = true,
  emptyText = "No access tags."
}) {
  const dispatch = useDispatch();
  const accessTags = useSelector(state => state.user.accessTags);
  const isCreating = useIsCreatingAccessTag();
  const options =
    restrictedOptions || (accessTags || []).map(tag => ({ id: tag.id, label: tag.title }));
  const latestValue = useRef(value);
  latestValue.current = value;

  const create = async title => {
    const action = await dispatch(quickCreateAccessTagAsync({ title, PlatformId: platformId }));
    const createdId = action.payload?.tag?.id;
    if (createdId) onChange([...latestValue.current, createdId]);
  };

  return (
    <LinkedItemsField
      id={id}
      value={value}
      onChange={onChange}
      options={options}
      searchLabel="Search access tags to add"
      searchPlaceholder={canCreate ? "Search or create tags..." : "Search access tags..."}
      allAddedText="Every access tag is already added"
      emptyText={emptyText}
      removeTitle="Remove access tag"
      renderMenuFooter={({ searchTerm, closeMenu }) => {
        if (!canCreate) return null;
        const title = searchTerm.trim();
        if (!title || options.some(o => o.label.toLowerCase() === title.toLowerCase())) return null;
        return (
          <MenuAction
            disabled={isCreating}
            onClick={() => {
              create(title);
              closeMenu();
            }}
          >
            Create new tag "{title}"
          </MenuAction>
        );
      }}
    />
  );
}
